import { useState } from 'react';
import { MenuItem, TextField, Typography } from '@material-ui/core';
import { Content, Header, Page, Progress, WarningPanel } from '@backstage/core-components';
import { IgnoresTable, useSnykIgnores } from './IgnoresTable';
import { statusOf, WARN_DAYS } from './status';

/** Todas las excepciones de los .snyk de deuna-platform, con su equipo, motivo, vencimiento y autor. */
export const SnykIgnoresPage = () => {
  const { data, error } = useSnykIgnores();
  const [owner, setOwner] = useState('');
  const rows = (data?.rows ?? []).filter(r => !owner || r.owner === owner);
  const owners = [...new Set((data?.rows ?? []).map(r => r.owner))].sort();
  const count = (s: string) => rows.filter(r => statusOf(r) === s).length;

  return (
    <Page themeId="tool">
      <Header title="Excepciones Snyk" subtitle="Vulnerabilidades ignoradas en el .snyk de cada repo de deuna-platform (se lee cada 6 h)" />
      <Content>
        {error && <WarningPanel title="No se pudieron cargar las excepciones" message={error} />}
        {!data && !error && <Progress />}
        {data && (
          <>
            <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
              <TextField select size="small" label="Equipo" value={owner} onChange={e => setOwner(e.target.value)} style={{ minWidth: 200 }}>
                <MenuItem value="">Todos</MenuItem>
                {owners.map(o => (
                  <MenuItem key={o} value={o}>
                    {o}
                  </MenuItem>
                ))}
              </TextField>
              <Typography>
                <b>{rows.length}</b> excepciones · <b style={{ color: '#d32f2f' }}>{count('vencida')} vencidas</b> ·{' '}
                <b style={{ color: '#d32f2f' }}>{count('por-vencer')} vencen en &lt; {WARN_DAYS} días</b> · {count('sin-vencimiento')} sin vencimiento ·{' '}
                {data.repos} repos con .snyk
              </Typography>
            </div>
            <IgnoresTable
              rows={rows}
              showRepo
              title={data.updatedAt ? `Actualizado ${new Date(data.updatedAt).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' })}` : 'Primera lectura en curso'}
            />
          </>
        )}
      </Content>
    </Page>
  );
};
